import common from "module/common";

function createAuthRequest(route, data = {}, useForm = false) {
  const request = common.httpPost(route);

  if (useForm) {
    request.type('form');
  }

  return request.data(data);
}

export function fetchAuthenticatedUser({data = {}, useForm = false} = {}) {
  return Promise.all([
    createAuthRequest('auth/me', data, useForm),
    createAuthRequest('auth/bootstrap', data, useForm)
  ]).then(([meResponse, bootstrapResponse]) => {
    return _.merge(
      {},
      _.get(meResponse, 'data.loggedInUser', {}),
      _.get(bootstrapResponse, 'data.loggedInUser', {})
    );
  });
}
